import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 200;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  menuButton: {
    color: theme.palette.custom.sidebarText,
    padding: '0px',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  companySelector: {
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.custom.sidebarSelectorBackground,
      color: theme.palette.custom.sidebarSelectorText,
      borderRadius: '5px',
      textAlign: 'center',
      height: '45px',
      marginBottom: '10px',
    },
  },
  drawerOpen: {
    fill: theme.palette.custom.sidebarText,
    color: theme.palette.custom.sidebarText,
    backgroundColor: theme.palette.custom.sidebarBackground,
    width: drawerWidth,
    padding: '17px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    color: theme.palette.custom.sidebarText,
    backgroundColor: theme.palette.custom.sidebarBackground,
    padding: '17px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '80px',
    '& .MuiListItemIcon-root': {
      marginLeft: '8px',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '15px',
    marginTop: '15px',
  },
  toolbarClose: {
    margin: '15px auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  iconOpen: {
    color: theme.palette.custom.sidebarIcon,
  },
  iconClose: {
    color: theme.palette.custom.sidebarMutedText,
    '&:hover': {
      color: theme.palette.custom.sidebarText,
    },
  },
  iconSelected: {
    color: theme.palette.custom.sidebarSelectedText,
  },
  redIcon: {
    color: theme.palette.custom.sidebarLogoutIcon,
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },
  image: {
    margin: '0 !important',
    maxWidth: '40px',
    maxHeight: '100%',
  },
  // The lockup asset (4403x966, ~4.56:1) already contains the "TCG Scout"
  // wordmark, so it replaces the old mark + `company` text span pair. It fills
  // the open drawer's usable width (200px minus 17px padding each side).
  logoLockup: {
    margin: '0 !important',
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
  },
  company: {
    fontFamily: 'Sora, sans-serif',
    fontWeight: 'bold',
    fontSize: '24px',
    color: theme.palette.custom.sidebarText,
    whiteSpace: 'pre-line',

    '& span': {
      backgroundImage: 'linear-gradient(to right, #38bdf8 ,#67e8f9 , #60a5fa)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent',
    },
  },
  tabTitle: {
    color: theme.palette.custom.sidebarText,
    textTransform: 'uppercase',
    fontSize: '10px',
    lineHeight: '16px',
    fontWeight: '800',
    marginLeft: '10px',
  },
  tabTitleOpen: {
    color: theme.palette.custom.sidebarText,
  },
  tabTitleClose: {
    color: theme.palette.custom.sidebarMutedText,
    textAlign: 'center',
    marginLeft: '0px',
  },
  dividerClose: {
    backgroundColor: theme.palette.custom.sidebarDividerClosed,
  },
  dividerOpen: {
    backgroundColor: theme.palette.divider,
  },
  containerTabItems: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '& .MuiListItemText-primary': {
      fontSize: '0.875rem',
    },
    '& .MuiSvgIcon-root': {
      height: '17px',
    },
  },
  listItemSelected: {
    color: theme.palette.custom.sidebarSelectedText,
    backgroundColor: theme.palette.custom.sidebarSelectedBackground,
    borderRadius: '5px',
    '& svg': {
      color: theme.palette.custom.sidebarSelectedText,
    },
  },
  listSubItemSelected: {
    '& .MuiListItemText-primary': {
      fontWeight: '600',
    },
    '& svg': {
      color: theme.palette.custom.sidebarSelectedText,
    },
  },
  listSubItem: {
    paddingLeft: '25px',
    '& .MuiListItemText-primary': {
      fontSize: '12px',
    },
  },
  listSubItemDouble: {
    paddingLeft: '35px',
    '& .MuiListItemText-primary': {
      fontSize: '12px',
    },
  },
  bottomContainer: {
    marginBottom: '10vh',
  },
}));

export default useStyles;
